// extracted by mini-css-extract-plugin
export const facebook = "SocialButton__facebook__x40Dq";
export const linkedin = "SocialButton__linkedin__fLGRW";
export const socialButton = "SocialButton__socialButton__DxlTH";
export const socialButtonLink = "SocialButton__socialButtonLink__Y5VGV";
export const twitter = "SocialButton__twitter__urhYU";